import { Component, OnInit, OnDestroy } from '@angular/core';
import { MyHouseDetailsModel } from '../../../../../models/MyHouseModel';
import { SubscriptionService } from '../../../../../shared/services/subscription.service';
import { MyhouseService } from '../../../../../services/myhouse.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Utilities } from '../../../../../Utilities';
import { Lightbox } from 'angular2-lightbox';
@Component({
  selector: 'app-myhouse-grid',
  templateUrl: './myhouse-grid.component.html',
  styleUrls: ['./myhouse-grid.component.css']
})
export class MyhouseGridComponent implements OnInit, OnDestroy {
  public myHouseDetailList: MyHouseDetailsModel[] = [];
  public apiUrl: string = Utilities.getSecureFileUrl;
  private subscriptions: Subscription[] = [];

  constructor(public myhouseService: MyhouseService,
    public subscriptionService: SubscriptionService,
    public lightbox: Lightbox,
    public route: ActivatedRoute) {
  }

  ngOnInit() {
    this.subscriptions.push(this.myhouseService.selectedSectionId.subscribe(sectionId => {
      if (sectionId && this.subscriptionService.CommunityLotId$.getValue()) {
        this.subscriptions.push(this.myhouseService.GetMyHouseDetailsByCommunityLotID(this.subscriptionService.CommunityLotId$.getValue(), +(sectionId)).subscribe(data => {
          this.myHouseDetailList = (data && data.MyHouseDetailsList) ? data.MyHouseDetailsList : [];
        }));
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  // onImageClick(imageName: string) {
  //   const album = {
  //     src: !imageName ? 'assets/img/NoImage.jpg' : this.apiUrl + imageName,
  //     caption: '',
  //     thumb: !imageName ? 'assets/img/NoImage.jpg' : this.apiUrl + imageName
  //   };
  //   this.lightbox.open([album], 0, { wrapAround: true, showImageNumberLabel: true });
  // }
  onImageClick(imageName: string) {
		
		const album = {
		  src: !imageName ? 'assets/img/NoImage.jpg' :imageName,
		  caption: '',
		  thumb: !imageName ? 'assets/img/NoImage.jpg' :imageName
		};
    this.lightbox.open([album], 0, { wrapAround: true, showImageNumberLabel: true });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/my-house/my-house-details/myhouse-grid/myhouse-grid.component.ts